import { GenericService } from './generic-service'

class EditoraService extends GenericService {
  constructor () {
    super('/editoras')
  }
}

export default new EditoraService()
